import React, { useState, useEffect, useCallback } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { XIcon } from '@heroicons/react/outline';
import classnames from 'classnames';

import Select from '../../../shared/inputs/Select';
import TextInput from '../../../shared/inputs/TextInput';

import { setAction, setSelectFilterAction } from '../actions/projectsPage';
import PrimaryButton from 'shared/buttons/PrimaryButton';
import { ButtonColor, ButtonType } from 'shared/buttons/models/ButtonModels';

export default function ProjectsViewSearch(props) {
  const dispatch = useDispatch();
  const { tags, creators, selectSortValue, selectCreatorValue, selectValue } = useSelector((state) => state.chartsPage);

  const resetSearch = useCallback(() => {
    dispatch(setAction({ page: 1 }));
    setQuery('');
    dispatch(
      setSelectFilterAction({
        query: ''
      })
    );
  }, []);

  const reset = () => {
    dispatch(setAction({ page: 1 }));
    setQuery('');
    dispatch(
      setSelectFilterAction({
        query: '',
        selectValue: [],
        selectCreatorValue: [],
        selectSortValue: { id: 0, name: 'Sort by most recent' }
      })
    );
  };

  useEffect(reset, []);

  const [query, setQuery] = useState('');

  const Search = (
    <TextInput
      name="search"
      value={query}
      reset={resetSearch}
      onChange={(e) => setQuery(e.target.value)}
      placeholder="Search by title"
      inputClassName={'highed-field-input'}
    />
  );

  const SelectTagsButton = (
    <Select
      options={tags}
      isMulti
      getOptionValue={(option) => option.id}
      getOptionLabel={(option) => option.name}
      onChange={(v) => {
        dispatch(setSelectFilterAction({ selectValue: v }));
      }}
      value={selectValue}
      className="form-group p-0"
      placeholder="Select tags"
    />
  );

  const SelectCreatorButton = (
    <Select
      options={creators}
      getOptionValue={(option) => option.id}
      getOptionLabel={(option) => option.username}
      onChange={(v) => {
        dispatch(setSelectFilterAction({ selectCreatorValue: v }));
      }}
      value={selectCreatorValue}
      className="form-group"
      isClearable
      placeholder="Creator"
    />
  );

  const SelectSortButton = (
    <Select
      options={[
        { id: 0, name: 'Sort by most recent' },
        { id: 1, name: 'Sort by date created' },
        { id: 2, name: 'Sort by name' }
      ]}
      isSearchable={false}
      getOptionValue={(option) => option.id}
      getOptionLabel={(option) => option.name}
      onChange={(v) => {
        dispatch(setSelectFilterAction({ selectSortValue: v }));
      }}
      value={selectSortValue}
      className="form-group"
      placeholder="Sort by"
    />
  );

  const SearchButton = (
    <PrimaryButton
      text={<i className="fa fa-search" />}
      buttonColor={ButtonColor.NavyBlue}
      buttonType={ButtonType.InputButton}
    />
  );

  const ResetFiltersButton = (
    <button onClick={reset}>
      <XIcon className="text-gray-500 hover:text-gray-700 ml-1 h-6 w-6" />
    </button>
  );

  return (
    <>
      <div className="charts-search rounded-tr-none mb-4 ev-sm:mb-6 ev-sm:flex">
        {!props.deleted && (
          <form
            className="flex flex-wrap w-full"
            onSubmit={(e) => {
              e.preventDefault();
              dispatch(
                setSelectFilterAction({
                  query: query
                })
              );
            }}
          >
            <div
              className={classnames('space-x-4', 'p-4', 'flex', 'flex-grow', {
                'justify-center rounded-md shadow-inner': props.simple
              })}
            >
              <div className="flex">
                {Search}
                {SearchButton}
              </div>
            </div>
            {!props.simple && <div className="p-4 gap-x-2 ev-md:flex hidden"></div>}
          </form>
        )}
      </div>
    </>
  );
}
